import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

import { IContactFlags } from '../model/contactFlag'

export const TOOLS_REQUIRED_HPID = ['BMI/IQ', 'BMI/IQ One Config', 'BMI/IQ Distributor', 'IQ']

export const PPA_FLAG = ['PFP Admin(PPA)', 'PFP user(PPU)']

export const emptyContactFlags: IContactFlags = {
  [ProfilingCodeType.Campaigns]: [],
  [ProfilingCodeType.Tools]: [],
  [ProfilingCodeType.UserRights]: [],
}

export const contactProlfilingCodeTypes = [
  ProfilingCodeType.Campaigns,
  ProfilingCodeType.Tools,
  ProfilingCodeType.UserRights,
]
